import {
  Button,
  Container,
  Grid,
  Heading,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { useNavigate, useRouteError } from 'react-router-dom'

import okAppkyLogo from '../assets/images/logo-ok-appky.svg'
import { Card, CardBody } from '../components/Card'
import { Section } from '../components/Section'
import { DismissCircle, Email, House, Refresh } from '../icons'

export const ErrorPage = () => {
  const error = useRouteError()
  const navigate = useNavigate()

  useEffect(() => {
    // TODO: Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <Section variant="login">
      <Container maxW="xl">
        <Card sx={{ mb: 8 }}>
          <CardBody>
            <Grid
              sx={{ gap: 5, justifyContent: 'center', justifyItems: 'center' }}
            >
              <DismissCircle boxSize={6} color="red.700" />

              <Heading as="h1" size="lg" color="red.700">
                Aplikace je v&nbsp;tuto chvíli nedostupná
              </Heading>

              <Image
                src={okAppkyLogo}
                sx={{ w: 'auto', maxW: '8rem', h: 12 }}
                alt="OK appky"
              />
            </Grid>

            <Stack alignItems="center" gap={4} mt={4}>
              <Button
                variant={'solid'}
                colorScheme="primary"
                className="btn btn-blue mt-6"
                onClick={
                  // Attempt to recover by trying to refresh the page
                  () => navigate(0)
                }
              >
                <Refresh />
                Zkusit znovu
              </Button>
              <Button
                variant={'solid'}
                className="btn btn-blue mt-6"
                onClick={() => navigate('/')}
              >
                <House /> Přejít na hlavní stránku
              </Button>
            </Stack>
          </CardBody>
        </Card>

        <ContactUsIfMistake />
      </Container>
    </Section>
  )
}

export const ContactUsIfMistake = () => {
  return (
    <Grid sx={{ gap: 2, justifyContent: 'center', justifyItems: 'center' }}>
      <Text sx={{ color: 'gray.500' }}>
        Pokud si myslíte, že se&nbsp;jedná o&nbsp;chybu, kontaktujte nás.
      </Text>

      <Button
        as="a"
        href="mailto:okappky@okholding.cz"
        variant="ghost"
        colorScheme="primary"
        leftIcon={<Email />}
      >
        Kontaktovat podporu
      </Button>
    </Grid>
  )
}
